import React from 'react';
import { Dropdown } from 'react-bootstrap';

import CardDropdown from 'components/common/CardDropdown';


const ResultsColumns = (handleOpenCertification, handleOpenEvaluation, handleDownloadReport, handleShowCertificate, handleDeleteCertificate) => [
    {
        accessor: 'index',
        Header: '#',
        headerProps: {
            style: { width: '30px', minWidth: '30px', maxWidth: '50px' }
        },
        cellProps: {
            style: { width: '30px', minWidth: '30px', maxWidth: '50px' }
        },
        Cell: rowData => {
            const { index } = rowData.row.original;
            return index+1;
        }
    },
    {
        accessor: 'none',
        Header: '',
        disableSortBy: true,
        headerProps: {
            style: { width: '50px', minWidth: '50px', maxWidth: '50px' }  // Ancho pequeño para el ícono del dropdown
        },
        cellProps: {
            className: 'text-end',
            style: { width: '50px', minWidth: '50px', maxWidth: '50px' }  // Ancho pequeño para el ícono del dropdown
        },
        Cell: rowData => {
            const { certification_id, name, email, total_score, level, completed_date, certification_type, candidate_type, college_name, status } = rowData.row.original;
            return (
                <CardDropdown>
                    <div className="py-2">
                        <Dropdown.Item onClick={() => handleOpenCertification(certification_id, name, email, college_name, certification_type, candidate_type, completed_date, status)}>Ver Examen</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleOpenEvaluation(certification_id, name, email, college_name, certification_type, candidate_type, completed_date, status)}>Evaluar</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleDownloadReport(certification_id, candidate_type, email, name)}>Descargar Reporte</Dropdown.Item>
                        <Dropdown.Item onClick={() => handleShowCertificate(certification_id, name, email, total_score, level, completed_date)}>Ver Certificado</Dropdown.Item>
                        <Dropdown.Divider />
                        <Dropdown.Item className="text-danger" onClick={() => handleDeleteCertificate(certification_id, name)}>Eliminar</Dropdown.Item>
                    </div>
                </CardDropdown>
            );
        }
    },
    { 
        accessor: 'certification_id', 
        Header: 'ID',
        headerProps: { className: 'hidden-column' },
        cellProps: {
              className: 'hidden-column'
        },
    },
    {
        accessor: 'name',
        Header: 'Nombre',
        headerProps: { className: 'ps-2' },
        cellProps: {
            className: 'white-space-nowrap pe-5 ps-2 py-2 fw-bold'
        }
    },
    {
        accessor: 'email',
        Header: 'Email',
        headerProps: { className: 'ps-2' },
        cellProps: { className: 'ps-2' }
    },
    {
        accessor: 'college_name',
        Header: 'Colegio',
        headerProps: {
            className: 'ps-2',
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' }
        },
        cellProps: {
            className: 'ps-2',
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' }
        }
    },
    { 
        accessor: 'certification_type', 
        Header: 'Tipo',
        headerProps: {
            className: 'ps-2',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'candidate_type', 
        Header: 'Candidato',
        headerProps: {
            className: 'ps-2',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    {
        accessor: 'assigned_date',
        Header: 'Fecha Inicio',
        headerProps: {
            className: 'ps-2',
            style: { width: '110px', minWidth: '110px', maxWidth: '110px' }
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '110px', minWidth: '110px', maxWidth: '110px' }
        }
    },
    { 
        accessor: 'completed_date', 
        Header: 'Finalizado',
        headerProps: {
            className: 'ps-2',
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '150px', minWidth: '150px', maxWidth: '200px' } // Establece el ancho fijo de la columna
        },
    },
    {
        accessor: 'status',
        Header: 'Estatus',
        headerProps: {
            className: 'ps-2',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' }
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' }
        }
    },
    { 
        accessor: 'total_score', 
        Header: 'Puntaje Total',
        headerProps: {
            className: 'ps-2',
            style: { width: '120px', minWidth: '120px', maxWidth: '120px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '120px', minWidth: '120px', maxWidth: '120px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'total_percentage', 
        Header: 'Porcentaje Total',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'level', 
        Header: 'Nivel',
        headerProps: {
            className: 'ps-2',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'grammar_score', 
        Header: 'Grammar',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'grammar_percentage', 
        Header: 'Porcentaje Grammar',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'reading_score', 
        Header: 'Reading',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'reading_percentage', 
        Header: 'Porcentaje Reading',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'listening_score', 
        Header: 'Listening',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'listening_percentage', 
        Header: 'Porcentaje Listening',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'writing_score', 
        Header: 'Writing',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'writing_percentage', 
        Header: 'Porcentaje Writing',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'speaking_score', 
        Header: 'Speaking',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    },
    { 
        accessor: 'speaking_percentage', 
        Header: 'Porcentaje Speaking',
        headerProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
        cellProps: {
            className: 'ps-2 text-center',
            style: { width: '100px', minWidth: '100px', maxWidth: '100px' } // Establece el ancho fijo de la columna
        },
    }
];

export default ResultsColumns;